import { render, staticRenderFns } from "./main-visual.vue?vue&type=template&id=05412e9b&scoped=true&"
import script from "./main-visual.vue?vue&type=script&lang=js&"
export * from "./main-visual.vue?vue&type=script&lang=js&"
import style0 from "./main-visual.vue?vue&type=style&index=0&id=05412e9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05412e9b",
  null
  
)

export default component.exports